module.exports = "/_next/static/images/apple-touch-icon-76-719e3dfa8b8ccf2bd6fde95657a75ce4.png";